import React, { Component } from 'react';

import moment from 'moment';

import { Button, Tooltip } from '@mui/material';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import Loader from '../../Loader';

export default class ChatMessage extends Component {
  state = {
    newestMsgId: 0,
    oldestMsgId: 0,
    showBoadMoreBtn: true,
  }

  componentDidMount() {
    const { messages, scrollToLastMsg } = this.props;

    if (messages && messages.length) {
      // Use setTimeout to ensure DOM is fully rendered
      setTimeout(() => {
        scrollToLastMsg();
      }, 100);
      
      if (messages.length < 20) this.setState({ showBoadMoreBtn: false });
    }
  };

  formatTime = (timestamp, userOffset = 0) => {
    // Get the local timezone offset in milliseconds using moment
    const localOffset = moment().utcOffset() * 60 * 1000; // Convert minutes to milliseconds

    // Use the user-provided offset if it exists, otherwise use the local offset
    const offsetToUse = userOffset || localOffset;

    // Adjust the timestamp to UTC
    const date = moment(timestamp).utcOffset(0).add(offsetToUse);

    // Format the date as DD MMM YYYY, HH:mm
    const formattedDate = date.format('DD MMM YYYY, HH:mm');

    // Get the adjusted current time based on the offset
    const adjustedCurrentTime = moment().utcOffset(offsetToUse).valueOf();

    // Calculate the difference in milliseconds
    const diffInMilliseconds = adjustedCurrentTime - moment(timestamp).utcOffset(offsetToUse).valueOf();

    // console.log(adjustedCurrentTime, timestamp);
    // console.log('userOffset:', userOffset, 'localOffset:', localOffset, 'offsetToUse:', offsetToUse, 'timestamp:', timestamp, 'formattedDate:', formattedDate);

    // Calculate days, hours, minutes, and seconds
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    const diffInSeconds = Math.floor(diffInMilliseconds / 1000);

    // Determine the closest time unit
    let elapsedTime;
    if (diffInDays >= 1) {
      elapsedTime = `${diffInDays}d`;
    } else if (diffInHours >= 1) {
      elapsedTime = `${diffInHours}h`;
    } else if (diffInMinutes >= 1) {
      elapsedTime = `${diffInMinutes}m`;
    } else {
      elapsedTime = `${diffInSeconds}s`;
    }

    // Combine the formatted date, time, and closest elapsed time
    const formattedTime = `[${formattedDate}]~${elapsedTime}`;

    return formattedTime;
  };

  scrollToBottom = () => {
    const chatContainer = document.querySelector('.talks-chat-inner');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  getSnapshotBeforeUpdate(prevProps) {
    const { messages } = this.props;
    const chatContainer = document.querySelector('.talks-chat-inner');

    if (messages !== prevProps.messages && chatContainer) {
      return {
        scrollHeight: chatContainer.scrollHeight,
        scrollTop: chatContainer.scrollTop,
        offsetHeight: chatContainer.offsetHeight
      };
    }
    return null;
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { scrollToLastMsg, messages, chatMsgLoaded } = this.props;
    const chatContainer = document.querySelector('.talks-chat-inner');

    if (messages !== prevProps.messages) {
      if (snapshot !== null && messages && messages.length) {
        // Check if we were at the bottom before update
        const wasAtBottom = snapshot.scrollHeight - snapshot.scrollTop === snapshot.offsetHeight;
        
        if (wasAtBottom) {
          // If we were at the bottom, scroll to bottom after update
          setTimeout(() => this.scrollToBottom(), 0);
        } else {
          // Maintain the relative scroll position
          chatContainer.scrollTop = chatContainer.scrollHeight - snapshot.scrollHeight + snapshot.scrollTop;
        }
      } else if (messages && messages.length) {
        // New messages loaded, scroll to bottom
        setTimeout(() => scrollToLastMsg(), 0);
      }
    }

    // Also scroll to bottom when messages become loaded
    if (!prevProps.chatMsgLoaded && chatMsgLoaded && messages && messages.length) {
      setTimeout(() => scrollToLastMsg(), 0);
    }
  };

  firstMesToShow = ((messages, n) => {
    return Object.keys(messages)
      .sort((a, b) => b - a)
      .slice(0, n)
      .reverse()
      .reduce(function(memo, current) {
        memo[current] = messages[current]
        return memo.filter(() => true)
      }, [])
  });

  loadMoreMessagesBtnClick = () => {
    const { loadMoreMsgs } = this.props;

    loadMoreMsgs(msgs => {
      if (msgs.length < 20) this.setState({ showBoadMoreBtn: false });
    });
  };

  render() {
    let { currentTime } = this.props;

    const {
      classes,
      account,
      subsData,
      messages,
      isTabsPresent,
      chatMsgLoaded,
      setupAccounts,
      onUnseenMsgClick,
      toggleDeleteMsgModal,
      onChatRecepientClick,
    } = this.props;

    return (
      <div
        className={classes.chatMessagesContainer}
        style={{
          height: `${isTabsPresent ? 'calc(100% - 55px)' : 'calc(100% - 28px)'}`,
        }}
      >
        <div
          className={`talks-chat-inner ${classes.chatMessagesContainerInner}`}
          style={!chatMsgLoaded || !messages.length ? { justifyContent: 'center', alignItems: 'center' } : {}}
        >
          <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', position: 'relative' }}>
            {this.state.showBoadMoreBtn && chatMsgLoaded && messages.length && messages.length >= 20 ? (
              <div>
                <Button
                  variant="outlined"
                  className={`talks-chat-inner-button ${classes.button}`}
                  style={{
                    zoom: '0.7',
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    this.loadMoreMessagesBtnClick();
                  }}
                >
                  {'Load more'}
                </Button>
              </div >
            ) : null}
          </div>

          {chatMsgLoaded && messages.length ? (
            messages.map((message) => {
              let index;
              messages.forEach((msg) => {
                if (msg.id === message.id) {
                  index = messages.indexOf(msg);
                }
              })
              const timeWithDST = moment(message.time).utcOffset(0).add(account.offset);
              const isNeedDate = moment(currentTime).date() === timeWithDST.date();
              const formattedTime = this.formatTime(message.time, account.offset);

              currentTime = timeWithDST;

              const actions = message.actionButtons
                ? message.actionButtons
                : message.postback_button
                ? [message.postback_button]
                : null;

              const chatMsgRecipient = (
                <span className={classes.chatMsgRecipient}>
                  {' '}
                  {message.sender === 0 ? (
                    <span>
                      <strong style={{ color: 'grey' }}>bot</strong> via
                    </span>
                  ) : message.sender_iid ? (
                    <span>
                      <a
                        target="blank"
                        style={{ color: '#063f9e' }}
                        className={classes.pointer}
                        onClick={() => onChatRecepientClick(setupAccounts[message.sender].iid)}
                      >
                        <strong>{setupAccounts[message.sender].individual.title}</strong>
                      </a>{' '}
                      via
                    </span>
                  ) : message.sender ? (
                    <span>
                      <strong>
                        {setupAccounts[message.sender] ? setupAccounts[message.sender].login : message.sender}
                      </strong>{' '}
                      via
                    </span>
                  ) : null}{' '}
                  {message.from}
                </span>
              );

              const chatMsgAdditionalInfo = `${message.incoming ? `${message.from} ` : ''} id:${message.id} ${
                message.flow ? ` f:${message.flow}` : ''
              } ${message.stimul ? ` s:${message.stimul}` : ''}`;

              return (
                <div key={message.id} className={classes.mb10}>
                  {!isNeedDate && (
                    <div className={classes.chatDateContainer}>
                      <p>{moment(timeWithDST).format('dddd, MMM DD, YYYY')}</p>
                    </div>
                  )}

                  <div
                    className={`talks-chat-msg
                  ${classes.chatMsgRow}
                  ${message.incoming ? classes.chatMsgRowIncome : classes.chatMsgRowOutcome}
                  ${message.incoming && !message.isSeen ? 'talks-message-unread' : ''}`}
                  >
                    <div
                      className={`talks-email ${classes.chatMsg} ${
                        message.incoming ? classes.chatMsgIncome : classes.chatMsgOutcome
                      }`}
                    >
                      {message.type !== 'deleted' ? (
                        <div
                          style={{
                            marginBottom: '10px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                          }}
                        >
                          <div className={classes.alignCenter}>
                            {!message.incoming ? chatMsgRecipient : null}

                            <span
                              className={classes.chatMsgDate}
                              title={chatMsgAdditionalInfo}
                              style={{ color: 'grey' }}
                            >
                              {formattedTime}
                            </span>

                            {message.status ?
                              <div
                                className={classes.ml20}
                                style={{
                                  padding: '0 6px 2px 6px',
                                  backgroundColor: message.status === 'delivered' ? '#4DBBFF' : '#FF4F4F',
                                  borderRadius: '6px',
                                  lineHeight: 1
                                }}
                              >
                                <span style={{ color: '#fff', fontSize: '9px' }}>
                                  {message.status}
                                </span>
                              </div>
                            : null}
                          </div>

                          <div className={`${classes.alignCenter}`}>
                            {message.incoming ? (
                              <Tooltip
                                title={message.notSeen ? "Mark as seen" : "Mark as not seen"}
                                placement="top"
                                classes={{
                                  tooltip: classes.muiTooltip,
                                }}
                              >
                                <div
                                  onClick={() => onUnseenMsgClick(message.id, message.notSeen, index)}
                                  style={{
                                    display: `${message.notSeen ? 'flex' : ''}`,
                                  }}
                                  className={`not-seen-container ${classes.chatMsgEyeIconContainer}`}
                                >
                                  <div className={classes.chatMsgEyeIconLine} />
                                  <VisibilityOutlinedIcon
                                    className={`${classes.chatMsgEyeIcon} ${
                                      message.notSeen ? classes.chatMsgEyeIconNotSeen : ''
                                    }`}
                                  />
                                </div>
                              </Tooltip>
                            ) : null}

                            <div className={classes.ml10} style={{ width: '20px' }}>
                              <Tooltip
                                title="Delete message"
                                placement="top"
                                classes={{
                                  tooltip: classes.muiTooltip,
                                }}
                              >
                                <div
                                  onClick={() => toggleDeleteMsgModal(true, message.id, index)}
                                  className={`not-seen-container ${classes.chatMsgEyeIconContainer}`}
                                >
                                  <DeleteOutlineOutlinedIcon
                                    className={`${classes.chatMsgEyeIcon} ${
                                      message.isSeen ? classes.chatMsgEyeIconNotSeen : ''
                                    } ${classes.deleteIcon}`}
                                  />
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {message.formatted_body ? (
                        <p
                          className={classes.chatMsgContent}
                          dangerouslySetInnerHTML={{
                            __html: message.formatted_body,
                          }}
                        />
                      ) : null}

                      {message.imgs && message.type !== 'deleted' ? (
                        <div className={classes.chatMsgImagesBlock}>
                          {message.imgs.map((imgUrl, index) => {
                            return (
                              <a key={index} href={imgUrl} className={classes.chatMsgImageLink} target="_blank" rel="noreferrer">
                                <img src={imgUrl} className={classes.chatMsgImage} alt="mail-img" />
                              </a>
                            );
                          })}
                        </div>
                      ) : null}

                      {message.files && message.type !== 'deleted' ? (
                        <div className={classes.chatMsgFilesBlock}>
                          {message.files.map((fileUrl, index) => {
                            return (
                              <a key={index} href={fileUrl} className={classes.chatMsgFile} rel="noreferrer" target="_blank">
                                {fileUrl}
                              </a>
                            );
                          })}
                        </div>
                      ) : null}

                      {message.pids && message.pids.length && message.type !== 'deleted' ? (
                        <div className={classes.chatMsgPidsBlock}>
                          {message.pids.map((pid, index) => {
                            let pidTitles = ``;

                            const requestedTrpls = message.requested_trpls;
                            const requestedTrpl = requestedTrpls ? message.requested_trpls[pid] || [] : [];

                            if (requestedTrpls && requestedTrpl) {
                              requestedTrpl.forEach((trpl, tIndex) => {
                                const isLast = tIndex === requestedTrpl.length - 1;

                                pidTitles += `[${trpl.tid}] : [${trpl.val}] ${isLast ? '' : '\n'}`;
                              });
                            }

                            return (
                              <div
                                key={index}
                                style={{
                                  backgroundColor: `${requestedTrpl.length ? '#ededed' : '#fff'}`,
                                }}
                                className={classes.chatPid}
                              >
                                <span title={pidTitles.toString()}>{subsData.restrictions[pid]}</span>
                              </div>
                            );
                          })}
                        </div>
                      ) : null}

                      {message.updated_trpls &&
                      Object.keys(message.updated_trpls).length &&
                      message.type !== 'deleted' ? (
                        <div className={classes.chatMsgPidsBlock}>
                          {Object.keys(message.updated_trpls).map((key, index) => {
                            return message.updated_trpls[key].map((trpl, tIndex) => {
                              return (
                                <div
                                  key={tIndex}
                                  style={{
                                    backgroundColor: '#ededed',
                                  }}
                                  className={classes.chatPid}
                                  title={trpl.tid}
                                >
                                  {trpl.val.length > 50 ? `${trpl.val.substr(0, 50)}...` : trpl.val}
                                </div>
                              );
                            });
                          })}
                        </div>
                      ) : null}

                      {actions && message.type !== 'deleted' ? (
                        <div className={classes.chatMsgBtnsBlock}>
                          {actions.map((btn, btnIndex) => {
                            return (
                              <div key={btnIndex} title={`postback: ${btn.postback}, type: ${btn.buttonType}`}>
                                <Button
                                  variant="outlined"
                                  className={classes.button}
                                  style={{
                                    zoom: '0.7',
                                    marginRight: '5px',
                                  }}
                                >
                                  {btn.caption || btn.buttonType || 'No text'}
                                </Button>
                              </div>
                            );
                          })}
                        </div>
                      ) : null}

                      {message.error && message.type !== 'deleted' ? (
                        <div className={classes.chatMsgErrorBlock}>{`Error: ${message.error.response}`}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })
          ) : !chatMsgLoaded ? (
            <Loader />
          ) : (
            <div className={classes.alignCenter}>
              <p className={classes.chatEmptyText}>No messages</p>
            </div>
          )}
        </div>
      </div>
    );
  }
};
